import React from 'react';

import { wrapper } from 'src/store';
import { fetchPageData, PageKeys, PagesSales } from 'src/modules/pages';

interface PagesSalesProps {}

const PageSales: React.FunctionComponent<PagesSalesProps> = () => <PagesSales />;

export const getServerSideProps = wrapper.getServerSideProps(
  async ({ store: { dispatch, getState } }) => {
    await fetchPageData(PageKeys.Sales)(dispatch, getState);
  }
);

export default PageSales;
